module.exports = __webpack_public_path__ + "img/cycle-1.648b2f01.jpg";